import Dashboard from './routers/Dashboard/index';
import IndexInfoAdd from './routers/IndexInfo/add';
import MenuConfig from './routers/Config/Menu';
import UsersConfig from './routers/Config/Users';
import News from './routers/News/index';
import NewsAdd from './routers/News/add';
import SinglePages from './routers/SinglePages/index';
import SinglePagesAdd from './routers/SinglePages/add';
import Site from './routers/Site/index';
import SiteAdd from './routers/Site/add';
import Album from './routers/Album/index';
import AlbumAdd from './routers/Album/add';

import Ads from './routers/Ads/index';
import AdsAdd from './routers/Ads/add';

import Login from './routers/Login/index';
import NotFound from './routers/NotFound/index';
const productRouter = [
  { path: '/content/products', name: '产品管理', exact: false, auth: true },
  {
    path: '/content/products/lists',
    name: '产品列表',
    exact: false,
    auth: true
  },
  {
    path: '/content/categories',
    name: '产品分类',
    component: Dashboard,
    exact: false,
    auth: true
  }
];
const newsRouter = [
  {
    path: '/content/news/:type',
    name: '新闻管理',
    component: News,
    exact: true,
    auth: true
  },
  {
    path: '/content/news/:type/add',
    name: '添加',
    component: NewsAdd,
    exact: false,
    auth: true
  },
  {
    path: '/content/news/:type/:id/edit',
    name: '编辑',
    component: NewsAdd,
    exact: false,
    auth: true
  }
];

const singlePagesRouter = [
  {
    path: '/content/singlePages',
    name: '单页管理',
    component: SinglePages,
    exact: true,
    auth: true
  },
  {
    path: '/content/singlePages/add',
    name: '添加',
    component: SinglePagesAdd,
    exact: false,
    auth: true
  },
  {
    path: '/content/singlePages/:id/edit',
    name: '编辑',
    component: SinglePagesAdd,
    exact: false,
    auth: true
  }
];

const albumRouter = [
  {
    path: '/content/album/:type',
    name: '相册管理',
    component: Album,
    exact: true,
    auth: true
  },
  {
    path: '/content/album/:type/add',
    name: '添加',
    component: AlbumAdd,
    exact: false,
    auth: true
  },
  {
    path: '/content/album/:type/:id/edit',
    name: '编辑',
    component: AlbumAdd,
    exact: false,
    auth: true
  }
];

const siteRouter = [
  {
    path: '/content/site',
    name: '站点管理',
    component: Site,
    exact: true,
    auth: true
  },
  {
    path: '/content/site/add',
    name: '添加',
    component: SiteAdd,
    exact: false,
    auth: true
  },
  {
    path: '/content/site/:id/edit',
    name: '编辑',
    component: SiteAdd,
    exact: false,
    auth: true
  }
];

const adsRouter = [
  {
    path: '/content/ads',
    name: '广告管理',
    component: Ads,
    exact: true,
    auth: true
  },
  {
    path: '/content/ads/add',
    name: '添加',
    component: AdsAdd,
    exact: false,
    auth: true
  },
  {
    path: '/content/ads/:id/edit',
    name: '编辑',
    component: AdsAdd,
    exact: false,
    auth: true
  }
];

const contentRouter = [
  {
    path: '/content',
    name: '内容管理',
    redirect: '/content/index',
    exact: true
  },
  {
    path: '/content/index',
    name: '内容管理首页',
    component: Dashboard,
    exact: false,
    auth: true
  },
  {
    path: '/content/indexInfo/:id/edit',
    name: '首页管理',
    component: IndexInfoAdd,
    exact: false,
    auth: true
  },
  ...productRouter,
  ...newsRouter,
  ...singlePagesRouter,
  ...albumRouter,
  ...siteRouter,
  ...adsRouter
];

const configRouter = [
  {
    path: '/config',
    name: '配置管理',
    redirect: '/config/users',
    exact: true
  },
  {
    path: '/config/menu',
    name: '菜单管理',
    component: MenuConfig,
    exact: false,
    auth: true
  },
  {
    path: '/config/users',
    name: '用户管理',
    component: UsersConfig,
    exact: false,
    auth: true
  }
];
const routerConfig = [
  {
    path: '/',
    component: IndexInfoAdd,
    redirect: '/content',
    exact: true,
    auth: true
  },

  {
    path: '/login',
    component: Login,
    exact: false,
    auth: false
  },

  {
    path: '/404',
    component: NotFound,
    exact: false,
    auth: false
  },
  ...contentRouter,
  ...configRouter
];
export default routerConfig;
